import { Building2, Users } from 'lucide-react'

import { SubTabShell, type SubTab } from '@/components/SubTabShell'

const SUBTABS: SubTab[] = [
  { path: '/main/partners',        label: '거래처 목록', Icon: Users,     matchExact: true, hint: '개별 거래처 관리' },
  { path: '/main/partners/groups', label: '상위 거래처', Icon: Building2, hint: '체인/그룹 단위 상위 거래처 관리 + 자동 제안' },
]

export function PartnersShell() {
  return (
    <SubTabShell
      Icon={Users}
      title="거래처관리"
      subtitle="개별 거래처 + 상위 (호텔/체인) 그룹"
      subtabs={SUBTABS}
    />
  )
}
